module.exports = __webpack_public_path__ + "img/not-select.30257603.svg";